import {
  DocumentOrganizationKeys,
  GoalFilterDocument,
  GroupByMode,
} from '@griply/types';

export const defaultGoalsOverviewFilterDocument: GoalFilterDocument = {
  [DocumentOrganizationKeys.SortingMode]: null,
  [DocumentOrganizationKeys.GroupByMode]: GroupByMode.None,
  // `null`, not `{}` — resetting must write a value that clears the stored
  // filters. `flattenSettings` drops empty objects, so `{}` would leave the
  // existing filters in place and the reset would do nothing.
  [DocumentOrganizationKeys.Filters]: null,
  [DocumentOrganizationKeys.CollapsedSections]: [],
};
